import React, { useEffect } from 'react';

import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';

import { CollectionOrder, DeliveryOrder } from '../../../weborder/Api';
import * as Api from '../../../weborder/Api';
import { basketSelectors } from '../../../weborder/redux';
import { BasketError } from '../../../weborder/selectors/basketSelectors';
import { stripeClient } from '../../../weborder/services';
import { ButtonPay } from './ButtonPay';

type StateProps = {
  checkoutErrors: WebOrder.State.BasketValidationError[];
  orderPayload: BasketError | DeliveryOrder | CollectionOrder;
  payment: WebOrder.State.Payment;
  stripeUpdatePayload: Stripe.PaymentRequestUpdateOptions;
  translate: any;
};

type OuterProps = {
  currency?: Api.Currency;
  currentLanguage?: string;
  disabled?: boolean;
  loading?: boolean;
  noPaymentsAvailable?: boolean;
  onClick: (event: any) => void;
  price?: number;
};

type Props = OuterProps & StateProps;

const ButtonPayStripeAlt = (props: Props): JSX.Element => {
  const {
    checkoutErrors,
    currency,
    currentLanguage,
    disabled = false,
    loading,
    noPaymentsAvailable,
    onClick,
    orderPayload,
    payment,
    price,
    stripeUpdatePayload,
    translate,
    ...buttonProps
  } = props;

  const status = payment && payment.status;
  const buttonText = payment ? payment.Description : translate('Loading');
  const noStripePayment = !payment;

  useEffect(() => {
    try {
      if (status === 'success') {
        // console.log('[STRIPE] UPDATE', stripeUpdatePayload);
        stripeClient.paymentRequest.update(stripeUpdatePayload);
      }
    } catch (error) {}
  }, [status, stripeUpdatePayload]);

  const onSubmit = (event) => {
    if (onClick) {
      onClick(event);
    }

    if (
      checkoutErrors.length ||
      typeof orderPayload === 'string' ||
      !orderPayload
    ) {
      // there r extra steps (missing name, missing time) so we need to call show() in confirm dialog
      // console.log('[STRIPE_PAY_BUTTON] VALIDATION', checkoutErrors);
      return;
    }
    // console.log('[STRIPE_PAY_BUTTON] SHOW');

    stripeClient.paymentRequest.show();
  };

  return (
    <ButtonPay
      {...buttonProps}
      disabled={disabled || noStripePayment}
      currency={currency}
      currentLanguage={currentLanguage}
      loading={loading}
      noPaymentsAvailable={noPaymentsAvailable}
      onSubmit={onSubmit}
      placeText={translate(buttonText).toString()}
      price={price}
      translate={translate}
    />
  );
};

const mapStateToProps = (state: WebOrder.State) => {
  const checkoutErrors = basketSelectors.getCheckoutErrors(state);
  const orderPayload = basketSelectors.getOrderPayload(state);
  const payment = basketSelectors.getSelectedPaymentOrDefault(state);
  const stripeUpdatePayload = basketSelectors.getStripePaymentRequestUpdateOptions(
    state,
  );

  return {
    checkoutErrors,
    orderPayload,
    payment,
    stripeUpdatePayload,
    translate: getTranslate(state.locale),
  };
};

export default connect(mapStateToProps)(ButtonPayStripeAlt);
